import React, { useRef, useState } from 'react'
import Box from '@mui/system/Box'
import Typography from '@mui/material/Typography'
import Icon from '@mui/material/Icon'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import NewClaimReport from '../components/NewClaimReport'
import SelectClaimReport from '../components/SelectClaimReport'

const NewReportModal = ({
  isModalOpen,
  handleOpen,
  handleClose,
  selectedClaimReport,
  setSelectedClaimReport,
  isNewClaimReport,
  setNewClaimReport,
  // state if click from allocation panel
  selectedCategory,
}) => {
  const refButton = useRef('button')
  const [buttonLoading, setButtonLoading] = useState(false)

  return (
    <AdxFormModal
      open={isModalOpen}
      onClose={handleClose}
      handleClose={handleClose}
      disableAutoFocus
      title="Claim report"
      subtitle="Please select a claim report for your expenses"
      icon={<Icon>arrow_upward</Icon>}
      enableFooter
      actionText={!isNewClaimReport ? 'Select' : 'Create'}
      handleAction={() => refButton.current.handleSubmit()}
      // actionButtonDisabled={!selectedClaimReport || refButton?.current?.isSubmitting}
      actionButtonDisabled={
        (!isNewClaimReport && !selectedClaimReport) || refButton?.current?.isSubmitting
      }
      sxModal={{
        width: { xs: 'calc(100vw - 24px)', sm: 'calc(100vw - 24px)', lg: 750 },
        minWidth: { xs: 'calc(100vw - 24px)', sm: 'auto' },
        maxWidth: { xs: 'calc(100vw - 24px)', sm: 'calc(100vw - 24px)', lg: 750 },
        maxHeight: { xs: 'calc(100dvh - 24px)', sm: 'calc(100dvh - 24px)' },
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '10px',
      }}
    >
      <Box display="flex" flexDirection="column" justifyContent="space-between">
        {!isNewClaimReport ? (
          <SelectClaimReport
            setNewClaimReport={setNewClaimReport}
            setSelectedClaimReport={setSelectedClaimReport}
            setButtonLoading={setButtonLoading}
            ref={refButton}
            selectedCategory={selectedCategory}
          />
        ) : (
          <NewClaimReport
            setNewClaimReport={setNewClaimReport}
            setButtonLoading={setButtonLoading}
            ref={refButton}
            selectedCategory={selectedCategory}
          />
        )}
        {/* <Box
          width={1}
          display="flex"
          flexDirection={{ xs: 'column-reverse', lg: 'row' }}
          justifyContent="center"
          alignContent="center"
          columnGap={2}
          marginTop={{ xs: 5, lg: 10 }}
          marginBottom={{ xs: 5, lg: 0 }}
        >
          <AdxButton variant={'ghost'} onClick={handleClose}>Cancel</AdxButton>
          <AdxButton
            disabled={!selectedClaimReport || refButton?.current?.isSubmitting}
            sx={{ width: { xs: 1, lg: 3 / 5 }, marginBottom: { xs: 1, lg: 0 } }}
            onClick={() => refButton.current.handleSubmit()}
          >
            {buttonLoading ? (
              <CircularProgress size={25} sx={{ color: 'white.main' }} />
            ) : !isNewClaimReport ? (
              'Select'
            ) : (
              'Create'
            )}
          </AdxButton>
        </Box> */}
      </Box>
    </AdxFormModal>
  )
}

export default NewReportModal
